import React from "react";
import { createRoot } from "react-dom/client";
import { installChunkRecovery } from "./utils/chunkRecovery";
import { installSecureConsole } from "./utils/installSecureConsole";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import { initRoutePreloader, preloadCriticalRoutes } from "./utils/routePreloader";

installSecureConsole();
installChunkRecovery();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);

// Expose a single, idempotent dismiss function that ProtectedRoute calls once
// it knows whether the user is authenticated. Keeping the HTML splash alive
// through both JS bundle load AND auth check prevents the double-loader flash
// (splash → React auth-loader → content).
let _splashGone = false;
window.__dismissAppSplash = () => {
  if (_splashGone) return;
  _splashGone = true;
  const splash = document.getElementById("app-splash");
  if (!splash) return;
  requestAnimationFrame(() => {
    splash.classList.add("app-splash--hidden");
    const remove = () => splash.remove();
    splash.addEventListener("transitionend", remove, { once: true });
    setTimeout(remove, 800);
  });
};

// Safety valve: always dismiss after 4s even if auth never resolves.
setTimeout(() => window.__dismissAppSplash?.(), 4000);

const isPublicEntry = () => {
  const path = window.location.pathname.replace(/\/$/, '') || '/';
  return path === '/login' || path === '/reset-password';
};

// After initial render, preload critical routes during idle time (skip on login screens)
if (!isPublicEntry()) {
  initRoutePreloader();
  preloadCriticalRoutes();
} else {
  initRoutePreloader();
}
